/**
 * Environment-specific constants and URLs
 */

// Public paths for different environments
export const STAGING_PUBLIC_PATH =
	'https://dev-agents.stg-east.frontend.public.atl-paas.net/assets/';
export const PROD_PUBLIC_PATH = 'https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/';

// Bitbucket domains
export const STG_BITBUCKET_DOMAIN = 'integration.bb-inf.net';
export const PROD_BITBUCKET_DOMAIN = 'bitbucket.org';

// Admin Hub URLs
export const ADMIN_HUB_BASE_URL_PROD = 'https://admin.atlassian.com';
export const ADMIN_HUB_BASE_URL_STG = 'https://admin.stg.atlassian.com';

// Integration management links
export const BITBUCKET_MANAGE_LINK = '/secure/admin/ConfigureDvcsOrganizations!default.jspa';
export const GITHUB_MANAGE_LINK_PROD =
	'/plugins/servlet/ac/com.github.integration.production/gh-addon-admin?s=com.github.integration.production__gh-addon-admin';
export const GITHUB_MANAGE_LINK_STG =
	'/plugins/servlet/ac/com.github.integration.staging/gh-addon-admin?s=com.github.integration.staging__gh-addon-admin';

// Setup and documentation links
export const BITBUCKET_SETUP_GUIDE_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/integrate-bitbucket-with-jira/';
export const GITHUB_INSTALL_LINK =
	'https://marketplace.atlassian.com/apps/1219592/github-for-jira?tab=overview&hosting=cloud';
export const GITHUB_SETUP_GUIDE_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/integrate-with-github/';

// Bitbucket Cloud agents settings
export const BBC_AGENTS_SETTINGS_LINK_PROD = 'https://bitbucket.org/account/workspaces/';
export const BBC_AGENTS_SETTINGS_LINK_STG = 'https://integration.bb-inf.net/account/workspaces/';

// Learn more links
export const WORK_WITH_ROVO_DEV_DOCS_URL =
	'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents/';
export const ROVO_DEV_STANDARD_TRIAL_DOCS_URL =
	'https://support.atlassian.com/rovo/docs/start-a-rovo-dev-standard-trial/';

export const CODING_AGENTS_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZmEwZmU2MTYwMGM3NDE3NjhlOTA2MDZhNGY5ZmU0OTU';
export const CODE_REVIEWER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/YWJmZmRiNTFhYTUxNDBhOTg5ZjY5ZmQ0Yzg5MTlkNzA';
export const DEPLOYMENT_SUMMARIZER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/OWYyYTFhNGEyNGUwNGY3YjgwMzkxMDhhMTAzM2EwYzc';
export const PIPELINE_TROUBLESHOOTER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZjBjMmQ3YmQzOThhNDY1MGEzZjRiMjM1NzA5YmNkZTU';
export const CODE_SEARCH_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/NzJlM2JlYjRmZTc1NGQ1NTk5NjUwNDFkYmE3NTZiODY';
export const ROVO_DEV_CLI_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/OWY5NjhmMDIyNjgzNDkxY2IyNjk4OTViOGIzZjM4ZDc';

// Settings and configuration links
export const DEPLOYMENT_SUMMARIZER_SETTINGS_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZTk0Y2QzMmFmMDVlNDNjNzlkYjg5YjUyOWJhOTIyZTQ';
export const PIPELINE_TROUBLESHOOTER_SETTINGS_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/NTgwMGQ3Yzg1ZThjNDQ5ZDhmZWYyNWVjN2ZjODExNmM';

// Waitlist and onboarding
export const JOIN_WAITLIST_LINK =
	'https://rovodevagents.atlassian.net/servicedesk/customer/portal/1';

// Rovo Dev CLI links
export const ROVO_DEV_CLI_USE_GUIDE_URL =
	'https://support.atlassian.com/rovo/docs/use-rovo-dev-cli/';
// ** DEPRECATED **
export const ROVO_DEV_CLI_READ_MORE_URL =
	'https://rovodevagents-beta.atlassian.net/wiki/external/Yzc2NzI4MTk3YTBhNDdiYjkzZDhhZTc3MjE0ZmE4Y2Q';
export const ROVO_DEV_CLI_INTRO_URL =
	'https://developer.atlassian.com/cloud/acli/guides/introduction/';
export const ROVO_DEV_CLI_MAC_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-macos/';
export const ROVO_DEV_CLI_LINUX_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-linux/';
export const ROVO_DEV_CLI_WINDOWS_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-windows/';
export const ROVO_DEV_CLI_TOKENS_URL =
	'https://id.atlassian.com/manage-profile/security/api-tokens?autofillToken&expiryDays=max&appId=rovodev&selectedScopes=all';
export const GITLAB_SERVICE_ACCOUNT_TOKENS_URL =
	'https://docs.gitlab.com/user/profile/service_accounts/#view-and-manage-personal-access-tokens-for-a-service-account';
export const BITBUCKET_DATA_CENTER_TOKENS_URL =
	'https://confluence.atlassian.com/bitbucketserver0717/personal-access-tokens-1087535496.html';
export const ROVO_DEV_CLI_BETA_LEARN_MORE_URL =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZDQxM2VhODI2MjJkNDI3M2IwMjgyNzNjZWIwYjJhYTM';
export const ROVO_DEV_STANDARD_PRICING_LINK = 'https://www.atlassian.com/software/rovo-dev/pricing';

// Rovo Dev in Jira links
export const ROVO_DEV_IN_JIRA_GUIDE_URL =
	'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-in-jira/';
export const JIRA_CODING_AGENT_GUIDE_URL =
	'https://support.atlassian.com/jira-software-cloud/docs/set-up-jira-coding-agent-in-your-organization/';

// Rovo Dev in Automations links
export const ROVO_DEV_AUTOMATION_GUIDE_URL =
	'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-in-automations/';

// Error constants
export const NOT_ATLASSIAN_USER_ERROR = 'Not an Atlassian user';

export const CODE_REVIEWER_LEARN_MORE_SAC_LINK =
	'https://support.atlassian.com/rovo/docs/activate-code-reviews-in-your-repository/';
export const CLI_INSTRUCTIONS_VIDEO_URL =
	'https://www.youtube.com/embed/OTgOulR4IZ0?si=Wgmg_AEKZWOcS-9V';
export const CODE_REVIEW_INSTRUCTIONS_VIDEO_URL =
	'https://dam-cdn.atl.orangelogic.com/AssetLink/qe61ptsy7bb01i22on613t388a502hvy.mp4';
export const CODE_REVIEW_ENABLED_GUIDE_URL =
	'https://support.atlassian.com/rovo/docs/enable-code-reviews/';

export const JIRA_TRIAL_LINK = 'https://www.atlassian.com/software/jira/try';

// Logo
export const ROVO_DEV_ICON_LIGHT_URL =
	'https://dam-cdn.atl.orangelogic.com/AssetLink/oifi18gd3n6kht71g3s81g1t7181w128.svg';
export const ROVO_DEV_ICON_DARK_URL =
	'https://dam-cdn.atl.orangelogic.com/AssetLink/gj3058bs3202y2t8m45a1x3u854kr650.svg';

// Get support link
export const GET_SUPPORT_LINK = 'https://support.atlassian.com/contact';
